import { apiClient } from '../../../api/client'
import type { ManagerList, ManagerListPage, ManagerListUpsert } from '../types'

const BASE = '/management/manager-lists'

/**
 * Silinmemiş listeler (ada göre Türkçe alfabetik, kişileriyle birlikte). Parametre ölçeği küçük →
 * tek sayfa çekilir, sayfalama istemcide yapılır.
 *
 * `q` ad araması **sunucuda** süzülür: TR-farkında karşılaştırma (`i` ↔ `İ`) orada yazılı, istemcide
 * ikinci bir kopyası tutulmaz.
 */
export async function getManagerLists(q?: string): Promise<ManagerListPage> {
  const { data } = await apiClient.get<ManagerListPage>(BASE, {
    params: { page: 0, size: 200, ...(q ? { q } : {}) },
  })
  return data
}

/** Yeni liste (201 → oluşturulan kayıt, kişileriyle). */
export async function createManagerList(body: ManagerListUpsert): Promise<ManagerList> {
  const { data } = await apiClient.post<ManagerList>(BASE, body)
  return data
}

/** Ad + kişi kümesini güncelle (optimistic lock için `modDate` zorunlu). */
export async function updateManagerList(
  id: number,
  body: ManagerListUpsert,
): Promise<ManagerList> {
  const { data } = await apiClient.put<ManagerList>(`${BASE}/${id}`, body)
  return data
}

/** Soft-delete (liste ve kişileri `record_status=2`). 204. */
export async function deleteManagerList(id: number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}`)
}
